import React from 'react';
import Modal from 'app/components/Modal';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import modalStyles from 'shared/components/modalStyles';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column'
import "primereact/resources/themes/lara-light-indigo/theme.css";
import messages, { FormattedMessage } from 'shared/messages/messages';

import { getAspectRatio } from 'app/utils/Utils';

const styles = () => ({
    inputGroup: {
        padding: '0.3rem 0'
    },
    selectionContainer: {
        display: 'grid',
        gridTemplateColumns: 'auto auto',
        gap: '10px'
    },
    printCountOption: {
        width: '3em',
        textAlign: 'center'
    },
    ...modalStyles()
});

class SelectedPrintsPreviewModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            printSizeSelection: [],
            selectedPrintSizes: []
        }

    }

    saveSelectedPrints = () => {
        this.props.onClose();
    }


    printCount(momentId) {
        const {
            selectedPrintMomentIds,
        } = this.props;

        return selectedPrintMomentIds.filter(id => id === momentId).length;
    }

    renderImageColumnTemplate = (rowData) => {
        return <img style={{ width: '5em' }} src={rowData.thumb_url} />
    }

    renderAspectRatioTemplate = (rowData) => {
        const aspectLabel = getAspectRatio(rowData.moment_width, rowData.moment_height);

        return <span ><label>{aspectLabel}</label></span>
    }

    renderImageSelection() {
        const { classes, selectedPrintSizes } = this.props;

        let slide = {};

        slide.component = (
            <div>
                <div className={classes.modalHeader}>
                    <span style={{ fontWeight: 600 }}><FormattedMessage {...messages.kiosk_selected_print_sizes_header} /></span>
                </div>
                <div className={classes.selectionContainer}>
                    <DataTable value={selectedPrintSizes}>
                        <Column header={<FormattedMessage {...messages.kiosk_selected_print_sizes_photo_column} />} field='thumb_url' body={this.renderImageColumnTemplate} />
                        <Column header={<FormattedMessage {...messages.kiosk_selected_print_sizes_aspect_column} />} body={this.renderAspectRatioTemplate} />
                        <Column header={<FormattedMessage {...messages.kiosk_selected_print_sizes_size_column} />} field='print_size' />
                        <Column header={<FormattedMessage {...messages.kiosk_selected_print_sizes_quantity_column} />} field='print_count' />
                    </DataTable>
                </div>
            </div>
        );

        slide.nextLabel = <FormattedMessage {...messages.button_close} />;
        slide.onNext = () => this.saveSelectedPrints();

        return slide;
    }


    render() {
        const slides = [];
        slides.push(this.renderImageSelection());
        return <Modal slides={slides} open={this.props.isOpen} onClose={() => this.props.onClose()} />;
    }
}

const mapStateToProps = state => ({
    settings: state.kioskReducer.settings,
    user: state.kioskReducer.user,
    printSizes: state.kioskReducer.printSizes,
    selectedPrintMomentIds: state.cartReducer.selectedPrintMomentIds,
    selectedPrintSizes: state.cartReducer.selectedPrintSizes
});

export default connect(mapStateToProps, {})(withStyles(styles)(SelectedPrintsPreviewModal));